import React from 'react';
import { LinkModel } from '@/types';
import Link from './Link';
import classNames from 'classnames';

type BreadcrumbsProps = {
  data?: LinkModel[];
} & React.HTMLAttributes<HTMLElement>;
const Breadcrumbs = ({ data, className, ...props }: BreadcrumbsProps) => {
  if (!data) return null;
  return (
    <ul
      className={classNames('flex flex-wrap items-center gap-1 text-base leading-[22px] font-medium', className)}
      {...props}
    >
      {data.map((item, index) => (
        <>
          <li key={index}>
            {item.href ? (
              <Link link={item} className="opacity-50 transition-all duration-300 hover:underline" />
            ) : (
              item.text
            )}
          </li>
          {index < data.length - 1 && <li className="opacity-50">/</li>}
        </>
      ))}
    </ul>
  );
};

export default Breadcrumbs;
